import React from "react";
import { TextField } from "@mui/material";

const GenericTextField = ({
  label,
  value,
  onChange,
  required = false,
  error = false,
  helperText = "Only alphanumeric, spaces, dots, and hyphens allowed",
  disabled = false,
  placeholder = "",
  maxLength = 255,
  ...props
}) => {
  // Allow only alphanumeric, space, dot, and hyphen
  const handleInputChange = (e) => {
    const inputValue = e.target.value;
    const regex = /^[a-zA-Z0-9 .-]*$/;
    if (inputValue === "" || regex.test(inputValue)) {
      onChange(e);
    }
  };

  return (
    <TextField
      margin="dense"
      size="small"
      variant="outlined"
      label={label}
      value={value}
      onChange={handleInputChange}
      required={required}
      error={error}
      helperText={helperText}
      disabled={disabled}
      placeholder={placeholder}
    //   slotProps={{ formHelperText: { sx: { textDecoration: "underline" } } }}
      fullWidth
      {...props}
      sx={{backgroundColor: "white", borderRadius: "6px", 
        "& .MuiOutlinedInput-root": {
            "& fieldset": {
                borderColor: error ? "red" : "rgba(0, 0, 0, 0.23)",
            },
            "&:hover fieldset": {
                borderColor: error ? "red" : "rgba(0, 0, 0, 0.6)",
            },
            "&.Mui-focused fieldset": {
                borderColor: error ? "red" : "#06adaf",
            },
        },
        "& .MuiFormLabel-asterisk": {
            color: required ? "red" : "inherit",
        },
        "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
            borderColor: "#06adaf",
        },
        "& .MuiOutlinedInput-root.Mui-focused fieldset": {
            borderColor: "#06adaf",
        },
        ...props.sx}}
    />
  );
};

export default GenericTextField;
